import {
  Box, Button, DashboardModule, Form,
} from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import useAdCopy, { useAdCopyForm } from '@hooks/useAdCopy'

import { AdCopyModel } from '@models/types'

interface AdCopyItemParams {
  adCopy: AdCopyModel,
  title: 'Default' | 'Digital' | 'Editorial' | 'Newspaper' | 'Print' | 'Signboards',
}

const AdCopyItem = (props: AdCopyItemParams) => {
  const {
    adCopy, title,
  } = props

  const adCopyPayload = useAdCopy(adCopy)
  const {
    callbacks: { createOrUpdateAdCopy },
  } = adCopyPayload

  const {
    entityState,
    entityState: { tagline, description },
    handlers,
  } = useAdCopyForm(adCopy)

  const createOrUpdateAdCopyPayload = {
    callbacks: {
      action: createOrUpdateAdCopy,
    },
    entityParams: entityState,
    toastText: 'Ad Copy Updated',
  }

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title={title}>
      <Box flexDirection="column" padding="large">
        <Form.Field label="Tagline">
          <input
            name="tagline"
            onBlur={() => handleCallbackAction(createOrUpdateAdCopyPayload)}
            onChange={handlers.onChange}
            type="text"
            value={tagline}
          />
        </Form.Field>

        <Form.Field label="Description" marginTop="large">
          <textarea
            name="description"
            onBlur={() => handleCallbackAction(createOrUpdateAdCopyPayload)}
            // @ts-expect-error TS2322
            onChange={handlers.onChange}
            value={description}
            style={{ minHeight: 120, resize: 'vertical' }}
          />
        </Form.Field>
      </Box>
    </DashboardModule>
  )
}

export default AdCopyItem
